<template>
  <div class="match-table">
    <div class="success">
      <p>
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-success-tianchong"></use>
        </svg>
        <span>{{
          $t('seller.productTable.bulkSuccessCount', {
            count: props.dataList.successList.length,
          })
        }}</span>
      </p>
      <artmisads-table
        :bordered="true"
        :columns="columnsSuccess"
        row-key="id"
        :change="onChangeSuccessPage"
        rowClassName="table-item"
        :data-source="props.dataList.successList"
        :scroll="{ y: 231 }"
        :pagination="{
          current: successPage,
          total: props.dataList.successList.length,
          defaultPageSize: 10,
        }"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.name === 'commission'">
            <span
              :class="
                record.status === 'active'
                  ? 'active-commission'
                  : 'inactive-commission'
              "
              >{{ `${Number(record.commission).toFixed(1)}%` }}</span
            >
          </template>
          <template v-if="column.name === 'beforeStatus'">
            <showStatus
              :isActive="record?.beforeStatus.toUpperCase() === 'ACTIVE'"
              :noBorder="true"
            />
          </template>
          <template v-if="column.name === 'afterStatus'">
            <showStatus
              :isActive="record?.afterStatus.toUpperCase() === 'ACTIVE'"
              :noBorder="true"
            />
          </template>
        </template>
      </artmisads-table>
    </div>
    <div class="operation-btn">
      <!-- <artmisads-button @click="onBack">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-jiantou-zuo-cu"></use>
        </svg>
        Back
      </artmisads-button> -->
      <div class="update">
        <artmisads-button @click="onDown" v-if="props.dataList.failList.length">{{
          $t('seller.productTable.downloadFailedRows')
        }}</artmisads-button>
        <artmisads-button
          v-if="props.dataList.successList.length && !loading"
          type="primary"
          @click="onUpdate"
          >{{ $t('seller.productTable.submitSuccessfulMatches') }}</artmisads-button
        >
        <artmisads-button v-else disabled>{{
          $t('seller.productTable.submitSuccessfulMatches')
        }}</artmisads-button>
      </div>
    </div>
    <div class="fail" v-if="props.dataList.failList.length">
      <p>
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-a-error-tianchong5"></use>
        </svg>
        <span>{{
          $t('seller.productTable.bulkFailCount', {
            count: props.dataList.failList.length,
          })
        }}</span>
      </p>
      <artmisads-table
        bordered
        :columns="columnsFail"
        row-key="id"
        rowClassName="table-item"
        :data-source="props.dataList.failList"
        :change="onChangeFailPage"
        :scroll="{ y: 275 }"
        :pagination="{
          total: props.dataList.failList.length,
          defaultPageSize: 10,
          current: failPage,
        }"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.name === 'commission'">
            <span
              :class="
                record.status === 'active' || record.status === 'Active'
                  ? 'active-commission'
                  : 'inactive-commission'
              "
              >{{ `${Number(record.commission).toFixed(1)}%` }}</span
            >
          </template>
          <template v-if="column.name === 'status'">
            <!-- <showStatus :isActive="record.status === 'active' || record.status === 'Active'" :noBorder="true"/> -->
            {{
              record.status === 'active' || record.status === 'Active'
                ? $t('seller.common.active')
                : $t('seller.common.inactive')
            }}
          </template>
        </template>
      </artmisads-table>
    </div>
  </div>
</template>
<script lang="jsx" setup>
import { message } from 'ant-design-vue'
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import moment from 'moment'
import showStatus from '../../brands/components/showStatus.vue'
import { productsApi } from '../../../../../server/index'

const { t, locale } = useI18n()
const successPage = ref(1)
const failPage = ref(1)
const loading = ref(false)

const props = defineProps([
  'dataList',
  'setDataList',
  'setShowExample',
  'setShowUpdateProductModal',
  'getProductList',
  'onCancel',
  'activeTab',
])

const onChangeSuccessPage = ({ current }) => {
  successPage.value = current
}

const onChangeFailPage = ({ current }) => {
  failPage.value = current
}
// 导出CSV功能
const exportToCSV = (data, columns, filename) => {
  // 获取表头
  const headers = columns.map((col) => col.title)

  // 获取数据行
  const rows = data.map((row) => {
    return columns.map((col) => {
      const cellValue = row[col.dataIndex]
      // 处理包含逗号、引号或换行符的单元格
      if (cellValue === null || cellValue === undefined) {
        return ''
      }

      let value = String(cellValue)
      // 如果值包含逗号、双引号或换行符，需要用双引号包裹
      if (value.includes(',') || value.includes('"') || value.includes('\n')) {
        // 转义双引号
        value = value.replace(/"/g, '""')
        // 用双引号包裹
        value = `"${value}"`
      }
      return value
    })
  })

  // 组合CSV内容
  const csvContent = [
    headers.join(','), // 表头行
    ...rows.map((row) => row.join(',')), // 数据行
  ].join('\n')

  // 创建Blob对象
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })

  // 创建下载链接
  const link = document.createElement('a')
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', filename)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}

const onDown = () => {
  if (props.dataList.failList.length === 0) {
    message.info(t('seller.msg.noFailedExport'))
    return
  }

  const filename = t('seller.productTable.exportFailuresFileName')
  exportToCSV(props.dataList.failList, columnsFail.value, filename)
  message.success(t('seller.msg.exportSuccess'))
}
const onUpdate = async () => {
  loading.value = true
  let params = [...props.dataList.successList]
  params = params.map((item) => {
    item.commission = item.afterCommissionStr
    item.status = item.afterStatus
    return item
  })
  let res
  if (props.activeTab == '0') {
    res = await productsApi.doUpdateCommissionOrStatusCsv(params)
  } else {
    res = await productsApi.doUpdateAssociateCommissionOrStatusCsv(params)
  }
  const { success, error } = res
  if (success) {
    message.success(t('seller.msg.success'))
    props.getProductList()
    // props.onCancel(true);/
  }
  loading.value = false
}

const onBack = () => {
  props.setDataList({
    failList: [],
    successList: [],
  })
  props.setShowExample(true)
}

const buildColumnsFail = () => {
  if (props.activeTab == '0') {
    return [
      {
        title: t('seller.brandsPage.colAsin'),
        dataIndex: 'asin',
      },
      {
        title: t('seller.productTable.colAmazonSellerName'),
        dataIndex: 'amazonName',
      },
      {
        title: t('seller.productTable.colCommission'),
        dataIndex: 'commission',
      },
      {
        title: t('seller.productTable.colStatus'),
        dataIndex: 'status',
        name: 'status',
      },
      {
        title: t('seller.productTable.colFailureReason'),
        dataIndex: 'errorMsg',
        name: 'failureReason',
      },
    ]
  }
  return [
    {
      title: t('seller.brandsPage.colAsin'),
      dataIndex: 'asin',
    },
    {
      title: t('seller.productTable.colAmazonSellerName'),
      dataIndex: 'amazonName',
    },
    {
      title: t('seller.productTable.colFailureReason'),
      dataIndex: 'errorMsg',
    },
  ]
}

const buildColumnsSuccess = () => {
  if (props.activeTab == '0') {
    return [
      {
        title: t('seller.productTable.colProduct'),
        dataIndex: 'title',
        width: '30%',
        customRender: ({ text, record }) => {
          return (
            <div class="product-item">
              <img src={record.imageUrl} />
              <div class="text">
                <span class="title">{text}</span>
                <span class="asin">{record.asin}</span>
              </div>
            </div>
          )
        },
      },
      {
        title: t('seller.productTable.colAmazonSellerName'),
        dataIndex: 'amazonName',
        width: '20%',
      },
      {
        title: t('seller.productTable.colCommission'),
        dataIndex: 'commission',
        width: '20%',
        children: [
          {
            title: t('seller.productTable.colBefore'),
            dataIndex: 'beforeCommissionStr',
            customRender: ({ text, record }) => `${text}%`,
          },
          {
            title: t('seller.productTable.colAfter'),
            dataIndex: 'afterCommissionStr',
            customRender: ({ text, record }) => `${text}%`,
          },
        ],
      },
      {
        title: t('seller.productTable.colStatus'),
        dataIndex: 'id',
        width: '20%',
        children: [
          {
            title: t('seller.productTable.colBefore'),
            dataIndex: 'beforeStatus',
            name: 'beforeStatus',
          },
          {
            title: t('seller.productTable.colAfter'),
            dataIndex: 'afterStatus',
            name: 'afterStatus',
          },
        ],
      },
    ]
  }
  return [
    {
      title: t('seller.brandsPage.colAsin'),
      dataIndex: 'asin',
    },
    {
      title: t('seller.productTable.colAmazonSellerName'),
      dataIndex: 'amazonName',
    },
    {
      title: t('seller.productTable.colAssociateStatus'),
      dataIndex: 'afterStatus',
      name: 'afterStatus',
    },
  ]
}

const columnsFail = ref([])
const columnsSuccess = ref([])
watch(
  () => [props.activeTab, locale.value],
  () => {
    columnsFail.value = buildColumnsFail()
    columnsSuccess.value = buildColumnsSuccess()
  },
  { immediate: true },
)
</script>

<style lang="less" scoped>
.match-table {
  padding-bottom: 12px;
  .success,
  .fail {
    > p {
      display: flex;
      color: var(--dark-1);
      letter-spacing: 0.4px;
      line-height: 20px;
      margin-bottom: 12px;
      font-weight: 500;
      svg {
        width: 24px;
        height: 24px;
        margin-right: 5px;
      }
      > span {
        align-self: center;
        font-size: 16px;
      }
    }
  }

  .success {
    padding: 8px 0 2px;
    > p {
      :deep(svg) {
        fill: var(--green-3);
      }
    }
  }
  .fail {
    margin: 0 -24px -24px;
    border-radius: 0 0 8px 8px;
    padding: 24px 24px 8px 24px;
    background-color: var(--bg-gray-1);
    border-top: 1px solid var(--border-4);
    > p {
      svg {
        fill: var(--red-1);
      }
    }
  }
  .operation-btn {
    display: flex;
    justify-content: flex-end;
    padding-bottom: 24px;
    > button {
      display: flex;
      svg {
        align-self: center;
        width: 18px;
        height: 18px;
        fill: var(--dark-2);
        margin-right: 8px;
      }
      :deep(span) {
        align-self: center;
      }
    }
    .update {
      > button {
        margin-left: 8px;
      }
    }
  }
  :deep(.ant-table) {
    .ant-table-cell {
      word-break: break-word;
      padding: 16px;
      line-height: 20px;
      border-color: var(--border-4) !important;
    }
    .ant-table-thead {
      border-radius: 8px 8px 0 0;
      overflow: hidden;
      .ant-table-cell {
        border-color: var(--border-1) !important;
        border-inline-end-color: var(--border-1) !important;
      }
    }
    .ant-table-container {
      border-color: var(--border-4) !important;
    }
    table {
      border-top: none !important;
      border-color: var(--border-4) !important;
    }
    .inactive-commission {
      color: var(--dark-4);
    }
    .status-text {
      text-transform: capitalize;
    }
    .product-item {
      display: flex;
      img {
        width: 60px;
        height: 60px;
        margin-right: 10px;
        object-fit: contain;
      }
      .text {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        justify-content: center;
        .title {
          max-width: 300px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .asin {
          margin-top: 4px;
        }
      }
    }
  }
}
</style>
